module.exports = __webpack_public_path__ + "img/vauraus.739b24c.png";